import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";

import {Auth, UIConfigContext} from "@digatex/digatex-ui-lib";

import App from "./App";
import {CurrentUserProvider} from "./contexts/AuthContext";
import {JIRA_DATA_KEY, UI_CONFIG} from "./properties";

import "./index.less";

import "react-app-polyfill/ie9";
import "url-search-params-polyfill";

function jiraHelpdesk(callback) {
	if (!JIRA_DATA_KEY) {
		console.warn("Jira Key not found, skipping widget load");
		callback();
		return;
	}

	var jhdScript = document.createElement("script");
	jhdScript.type = "text/javascript";
	jhdScript.setAttribute("data-jsd-embedded", null);
	jhdScript.setAttribute("data-key", JIRA_DATA_KEY);
	jhdScript.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
	jhdScript.src = "https://jsd-widget.atlassian.com/assets/embed.js";

	if (jhdScript.readyState) {
		jhdScript.onreadystatechange = function () {
			if (jhdScript.readyState === "loaded" || jhdScript.readyState === "complete") {
				jhdScript.onreadystatechange = null;
				callback();
			}
		};
	} else {
		jhdScript.onload = function () {
			callback();
		};
	}
	document.head.appendChild(jhdScript);
}

Auth.init(() =>
	jiraHelpdesk(function () {
		const DOMContentLoaded_event = new Event("DOMContentLoaded", {bubbles: true, cancelable: true});
		window.document.dispatchEvent(DOMContentLoaded_event);

		ReactDOM.render(
			<BrowserRouter>
				<UIConfigContext.Provider value={UI_CONFIG}>
					<CurrentUserProvider>
						<App />
					</CurrentUserProvider>
				</UIConfigContext.Provider>
			</BrowserRouter>,
			document.getElementById("root"),
		);
	}),
);
